export const timeout = (ms: number, error?: Error, callback?: () => void): Promise<void> =>
    new Promise((_, reject) =>
        setTimeout(() => {
            callback?.();
            reject(error);
        }, ms)
    );
